import { FdIconProps } from '../types/type'

const FdSymbol = ({ width = '4.1rem', height = '4.2rem' }: FdIconProps): JSX.Element => {
  return (
    <svg width={width} height={height} viewBox='0 0 41 42' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.0014 19.4909H11.373L6.90853 14.9089L8.98783 12.7749L17.0019 20.9999L8.98783 29.2248L6.90853 27.0908L11.373 22.5089H3.00137C3.74811 31.734 11.2801 38.982 20.4615 38.982C29.6429 38.982 37.1748 31.734 37.9216 22.5089H29.5503L34.0148 27.0908L31.9355 29.2248L23.9214 20.9999L31.9355 12.7749L34.0148 14.9089L29.5503 19.4909H37.9215C37.1747 10.2659 29.6428 3.01796 20.4615 3.01796C11.2801 3.01796 3.74825 10.2659 3.0014 19.4909ZM0 21C0 9.40202 9.16091 0 20.4615 0C31.762 0 40.9229 9.40202 40.9229 21C40.9229 32.598 31.762 42 20.4615 42C9.16091 42 0 32.598 0 21ZM14.5266 7.69937L20.4614 13.7903L26.3961 7.69937L28.4754 9.83339L20.4614 18.0584L12.4473 9.83339L14.5266 7.69937ZM20.4614 23.9419L28.4754 32.1669L26.3961 34.3009L20.4614 28.2099L14.5266 34.3009L12.4473 32.1669L20.4614 23.9419Z'
        fill='white'
      />
    </svg>
  )
}

export default FdSymbol
